import React, { FC } from "react";

import { defineMessages, useIntl } from "react-intl";

import Team from "@mapmycustomers/shared/types/Team";

import styles from "@app/scene/dashboard/components/Sidebar/components/ScopeList/components/LabelCommon.module.scss";

const messages = defineMessages({
  noTeam: {
    id: "dashboard.sidebar.noTeam",
    defaultMessage: "No Team",
    description: "No Team label in Dashboard sidebar when org name is not available",
  },
});

interface Props {
  team?: Team;
}

const TeamLabel: FC<Props> = ({ team }) => {
  const intl = useIntl();

  return (
    <div className={styles.container}>{team?.name ?? intl.formatMessage(messages.noTeam)}</div>
  );
};

export default TeamLabel;
